/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

/**
 * Trying Idea from https://medium.com/@gchudnov/using-es6-proxies-for-polymorphic-functions-54a7e04eb009
 * To see if it works for polymorphic functions
 */
export const createMultiMethod = (
  dispatch: (node?: unknown) => PropertyKey,
  noMatch: () => {
    undefined: undefined;
  }
) => {
  if (typeof dispatch !== "function") {
    throw new TypeError("dispatch must be a function");
  }

  const dict: Record<string, (...args: unknown[]) => unknown> = {};

  if (typeof noMatch === "function") {
    dict.noMatch = noMatch;
  }

  return new Proxy(
    () => {
      throw new Error("No match");
    },
    {
      set(target, property, value) {
        dict[property as string] = value;
        return true;
      },
      apply(target, thisArgument, args) {
        const value = dispatch(...args);
        const noMatchValue = Object.hasOwn(dict, "noMatch")
          ? dict.noMatch
          : target;
        const handlerFunction =
          value && Object.hasOwn(dict, value)
            ? dict[value as string]
            : noMatchValue;

        return handlerFunction.apply(thisArgument, args);
      },
    }
  );
};
